import { render, staticRenderFns } from "./radioIcon.vue?vue&type=template&id=0e9aeed2&"
import script from "./radioIcon.vue?vue&type=script&lang=js&"
export * from "./radioIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports